'use client';

import { Card, Modal, rem } from '@mantine/core';
import { useMemo } from 'react';
import AuthForm from '../components/auth-form';
import { useWindowSize } from '../hooks';

type AuthModalProps = {
  opened: boolean;
};

const AuthModal = ({ opened }: AuthModalProps) => {
  const { width: windowWidth } = useWindowSize();

  const isMobile = useMemo(
    () => Boolean(windowWidth) && windowWidth < 768,
    [windowWidth]
  );

  return (
    <Modal
      zIndex={1500}
      opened={opened}
      size={rem(450)}
      px={rem(24)}
      radius={rem(12)}
      fullScreen={isMobile}
      withCloseButton={false}
      centered
      closeOnClickOutside={false}
      closeOnEscape={false}
      onClose={() => {
        // do nothing
      }}
      styles={{
        body: {
          padding: 0,
          width: '100%',
          height: '100%',
          minHeight: rem(600),
          display: 'flex',
          flexDirection: 'column',
        },
        overlay: {
          zIndex: 1500,
        },
        inner: {
          zIndex: 1500,
        },
      }}
    >
      <Card
        p={{ base: '0', sm: rem(32) }}
        mih={{ base: '100svh', sm: rem(620) }}
      >
        <AuthForm />
      </Card>
    </Modal>
  );
};

export default AuthModal;
